<div class="w9-desk-brief">
  <div class="w9-desk-brief__header">
    <div class="w9-desk-brief__icon"><sm-sonder-avatar [size]="14" /></div>
    <span class="w9-desk-brief__name">Sonder</span>
  </div>
  <div class="w9-desk-brief__bubble">
    <p>{{ greeting() }} — I pulled your application data and pre-filled what I can below.</p>
    <p>
      Add your <strong>{{ tinLabel() }}</strong> directly on the W-9 to the left — look for
      the highlighted Tax ID field — then sign below it. No need to type it here in the chat.
    </p>
  </div>
</div>
